import { Button } from '@piplapps/pipl-ui';
import React from 'react';
import PropTypes from 'prop-types';
import styles from './UploadUsersListContainer.module.less';
import ValidIcon from '../../../../Assets/validation_icon.svg';

const SuccessModal = (props) => {
  return (
    <div className={styles.modalContainer}>
      <div className={styles.header}>{gettext('Users were successfully added!')}</div>
      <div className={styles.imageWrapper}>
        <img alt="" src={ValidIcon} />
      </div>
      <div className={[styles.text, styles.center].join(' ')}>
        {gettext('An email will be sent to: ')}
        <span className={styles.email}>{props.userEmail}</span>
      </div>
      <Button buttonClass="primary-blue" text={gettext('Close')} onClick={() => props.onClose()} />
    </div>
  );
};

SuccessModal.propTypes = {
  userEmail: PropTypes.string,
  onClose: PropTypes.func,
};

export default SuccessModal;
